import { ref, reactive, nextTick } from "vue";

import isEmpty from "lodash/isEmpty";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";


import { ElMessageBox } from "@/components/Vendor/Element";

export default function(formsDataArray) {
  let createFormsData = (forms) => {
    let formsData = {};
    let formsRefs = {};
    for (const [key] of Object.entries(forms)) {
      formsData[key] = formsDataArray[key];
      formsRefs[key] = ref({});
    }
    return [formsData, formsRefs];
  };

  let [formsData, formsRefs] = createFormsData(formsDataArray);

  formsData = reactive(formsData);

  const checkFieldsEqual = (formName) => {
    let formFieldsEqual = null;

    let resetValue = Object.values(formsData[formName]).some((x) => {
      return x.resetValue != undefined;
    });

    if (resetValue) {
      Object.values(formsData[formName]).forEach((x) => {
        if (
          x !== undefined &&
          x.value !== undefined &&
          x.resetValue !== undefined
        ) {
          if (x.resetValueSort) {
            let sortValue = x.value;
            let sortResetValue = x.resetValue;
            sortValue.sort();
            sortResetValue.sort();

            x.fieldChanged = !isEqual(sortValue, sortResetValue);
          } else {
            x.fieldChanged = !isEqual(x.value, x.resetValue);
          }
        }
      });
      formFieldsEqual = !Object.values(formsData[formName]).some(
        (x) => x && x.fieldChanged
      );
    }
    if (formFieldsEqual != null) {
      if (formFieldsEqual == true) {
        formsData[formName].disabled = true;
        formsData[formName].formChanged = false;
      } else {
        formsData[formName].formChanged = true;
      }
    }
  };

  const checkFormChanged = (formName, skip = false) => {
    return new Promise((resolve) => {
      if ((formsData[formName].formChanged && !skip) || formsData[formName].formChanged) {
        ElMessageBox.confirm(
          `If you leave this page, all changes will be lost. ${
            !formsData[formName].disabled
              ? "Please click 'Save Now' if you want to keep the changes you made."
              : ""
          } ${!formsData[formName].disabled ? "Save now if you want to save it." : ""}`,
          "Are you sure you want to leave the page?",
          {
            distinguishCancelAndClose: true,
            showConfirmButton: !formsData[formName].disabled,
            confirmButtonText: "Save Now",
            cancelButtonText: "Leave",
            confirmButtonClass: "el-button--green",
            cancelButtonClass: "el-button--grey",
            showClose: formsData[formName].disabled,
          }
        )
          .then(() => {
            ElMessageBox.close(); // 🚀 Force-close modal before resolving
            resolve("save");
          })
          .catch((error) => {
            ElMessageBox.close(); // 🚀 Ensure modal closes on any rejection
            if (error === "cancel") {
              resolve(true); // Allow navigation
            } else {
              resolve(false); // Prevent navigation
            }
          });
      } else {
        formsData[formName].formChanged = false;
        resolve(true);
      }
    });
  };
  
  
  

  const copyFormResetValue = (formName, changed) => {
    for (let formField in formsData[formName]) {
      if (formsData[formName][formField]) {
        let value = formsData[formName][formField].value;
        if (formsData[formName][formField].resetValue !== undefined) {
          if (typeof value === "object" && value !== null) {
            formsData[formName][formField].resetValue = cloneDeep(value);
          } else {
            formsData[formName][formField].resetValue = value;
          }
        }
      }
    }
    if (changed) {
      checkFieldsEqual(formName);
    }
  };

  const setFormRules = () => {
    let formNames = Object.keys(formsData);

    formNames.forEach((formName) => {
      let rules = {};
      for (let formField in formsData[formName]) {
        if (
          formsData[formName][formField] &&
          formsData[formName][formField].validators
        ) {
          formsData[formName][formField].valid = false;
          formsData[formName][formField].formName = formName;
          formsData[formName][formField].validators.forEach((element) => {
            if (!rules[formField]) {
              rules[formField] = [];
            }
            rules[formField].push(element);
          });
        }
      }
      if (!isEmpty(rules)) {
        formsData[formName].rules = rules;
      }
      copyFormResetValue(formName);
    });
  };
  if (formsData) {
    setFormRules();
  }

  const setFormRefs = () => {
    // formsRefs.userForm.value = formsData.userForm.ref;
    for (const [key] of Object.entries(formsData)) {
      // formsData[key] = formsDataArray[key];
      formsRefs[key].value = formsData[key].ref;
    }
  };

  const restoreFormMask = (formName, formField) => {
    const setMask = (formField) => {
      if (formField.ref && formField.value) {
        if (
          typeof formField.ref === "object" &&
          formField.ref !== null &&
          formField.ref.nodeType != 1
        ) {
          for (let refName in formField.ref) {
            formField.value[refName] = formField.ref[refName].maskRef.value;
          }
        } else {
          formField.value = formField.ref.maskRef.value;
        }
      }
    };
    if (formField) {
      setMask(formsData[formName][formField]);
    } else {
      for (let formField in formsData[formName]) {
        setMask(formsData[formName][formField]);
      }
    }
  };

  const onFormMaskAccept = (event, formName, field, callback = () => true) => {
    const maskRef = event.detail;
    if (maskRef.masked.rawInputValue == "") {
      maskRef.updateOptions({
        lazy: true,
      });
    } else {
      maskRef.updateOptions({
        lazy: false,
      });
    }
    let fieldName = field;
    if (field.value) {
      fieldName = field.name;
      formsData[formName][fieldName].value[field.value] = maskRef.value;
      formsRefs[formName].value.model[fieldName].value[field.value] =
        formsData[formName][fieldName].value[field.value];
    } else {
      formsData[formName][field].value = maskRef.value;
      formsRefs[formName].value.model[field].value =
        formsData[formName][field].value;
    }
    checkFormValidation(formName, false, fieldName);
    callback(formName, field);
  };

  const checkIfFormIsValid = function(formName) {
    let isValid = true;
    formsRefs[formName].forEach(formField => {
      console.log("Hello aa", formField);
    })
    return isValid;
  }
  const checkFormValidation = (formName, message, formField) => {
    
    let settings = {
      suppressWarning: false,
    };
    if (!message) {
      settings.suppressWarning = true;
    }
    
    if (formField) {
      nextTick(() => {
       
        formsRefs[formName].value.validateField(formField, null, settings);
      });
    } else {
      nextTick(() => {
        formsRefs[formName].value.validate((valid) => {
          if (valid) {
            setFormValidation(formName, false, true);
            return true;
          } else {
            setFormValidation(formName, false, false);
            return false;
          }
        }, settings);
      });
    }
  };

  const setFormValidation = (formName, formField, valid) => {
   
    if (formsRefs[formName].value.rules) {
      Object.keys(formsRefs[formName].value.rules).forEach((element) => {
        if (formField) {
          if (element == formField) {
            formsData[formName][formField].valid = valid;
          }
        } else {
          formsData[formName][element].valid = valid;
        }
      });

      let formFieldsDisabled = [];


      for (let formField in formsData[formName]) {
        if (
          formsData[formName][formField].validators &&
          formsData[formName][formField].active != false
        ) {
          formFieldsDisabled.push(formsData[formName][formField].valid);
        }
      }



      let isValidFormButNotChanged = true;
      if (formFieldsDisabled.length) {

        formFieldsDisabled.forEach( item => 
          {
            if (item === false) {
              isValidFormButNotChanged = false;
            }
          }
        );
        formFieldsDisabled.every((v) => v === true)
          ? (formsData[formName].disabled = false)
          : (formsData[formName].disabled = true);
      } else {
        formsData[formName].disabled = true;
      }

      //checking if the formfields are valid
      formsData[formName].isFormValid = isValidFormButNotChanged;

    } else {
      formsData[formName].disabled = false;
    }

    if (formsData[formName].disabled == false) {
      checkFieldsEqual(formName);
    }
  };

  const setFieldError = (formName, formField, error) => {
    if (formsData[formName][formField]) {
      formsData[formName][formField].errors = error;
    } else return false;
  };

  const setFormErrors = (formName, errors) => {
    for (let key in errors) {
      setFieldError(formName, key, errors[key]);
    }
  };

  const getFormValues = (formName) => {
  let formValues = {};
  
  // Process all form fields except more_option_internal_pools
  for (const [key, value] of Object.entries(formsData[formName])) {
    if (key === 'more_option_internal_pools') continue; // We'll handle this separately
    
    if (value.active != false) {
      if (value.ref && value.ref.maskRef) {
        if (typeof value.ref === "object" && value.ref !== null && value.ref.nodeType != 1) {
          for (let refName in value.ref) {
            formValues[refName] = value.ref[refName].maskRef.unmaskedValue;
          }
        } else {
          formValues[key] = value.ref.maskRef.unmaskedValue;
        }
      } else if (value?.value || value.valueImportant) {
        if (value.value instanceof Array && value.value.length && value.value[0]?.raw && typeof value.value[0]?.raw?.name == "string") {
          formValues[key] = value.value.map((x) => x.raw);
        } else {
          formValues[key] = value.value;
        }
      }
    }
  }
  
  // Handle more_option_internal_pools separately to maintain its structure
  if (formsData[formName].more_option_internal_pools) {
    formValues.more_option_internal_pools = {};
    
    Object.entries(formsData[formName].more_option_internal_pools).forEach(([poolId, poolData]) => {
      formValues.more_option_internal_pools[poolId] = {
        value: {
          value: poolData.value.value,
          locums: [...poolData.value.locums], // Create a new array
          tags: [...poolData.value.tags] // Create a new array
        }
      };
    });
  }
  
  return formValues;
};

  return {
    onFormMaskAccept,
    restoreFormMask,
    checkIfFormIsValid,
    checkFormValidation,
    copyFormResetValue,
    checkFieldsEqual,
    checkFormChanged,
    setFormValidation,
    setFieldError,
    setFormErrors,
    getFormValues,
    setFormRefs,
    formsData,
    formsRefs,
  };
}